import { render, staticRenderFns } from "./RelayCreateMultiBox.vue?vue&type=template&id=7c6a2823&"
import script from "./RelayCreateMultiBox.vue?vue&type=script&lang=ts&"
export * from "./RelayCreateMultiBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports